import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-step-configuration',
  templateUrl: './step-configuration.component.html'
})
export class StepConfigurationComponent implements OnInit, OnChanges {

  @Input() selectedMonth: string = '';
  @Input() selectedYear: string = '';
  @Input() isLoading: boolean = false;

  @Output() selectedMonthChange = new EventEmitter<string>();
  @Output() selectedYearChange = new EventEmitter<string>();
  @Output() next = new EventEmitter<void>();

  @Input() formatTxt: boolean = true;
  @Output() formatTxtChange = new EventEmitter<boolean>();

  @Input() formatXls: boolean = true;
  @Output() formatXlsChange = new EventEmitter<boolean>();

  years: number[] = [];

  ngOnInit(): void {
    // Generar lista de años
    this.years = this.getYearsRange(6);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Setear año/mes actual cuando aún esté vacío
    this.setCurrentMonthYearIfEmpty();
  }

  private setCurrentMonthYearIfEmpty(): void {
    const now = new Date();
    const currentYear = String(now.getFullYear());
    const currentMonth = String(now.getMonth() + 1).padStart(2, '0');

    if (!this.selectedYear) {
      this.selectedYear = currentYear;
      this.selectedYearChange.emit(this.selectedYear);
    }

    if (!this.selectedMonth) {
      this.selectedMonth = currentMonth;
      this.selectedMonthChange.emit(this.selectedMonth);
    }
  }

  getYearsRange(backYears: number): number[] {
    const currentYear = new Date().getFullYear();
    const startYear = currentYear - backYears;

    const years: number[] = [];
    for (let y = startYear; y <= currentYear; y++) {
      years.push(y);
    }

    return years;
  }

  onNext() {
    this.selectedMonthChange.emit(this.selectedMonth);
    this.selectedYearChange.emit(this.selectedYear);
    this.formatTxtChange.emit(this.formatTxt);
    this.formatXlsChange.emit(this.formatXls);
    this.next.emit();
  }
}
